export default __webpack_public_path__ + "static/media/sad-face.fce5b032.png";